import { PageSectionType } from '@/enums/page-section-type';
import { TrackingActions } from '@/enums/tracking-actions';
import { TrackingCategories } from '@/enums/tracking-categories';
import ITrackingObject from '../interfaces/tracking-object.interface';

export default class AccountPageTracker {
	public trackContentSwitch(container: PageSectionType, from: string, to: string): void {
		const trackingParams: ITrackingObject = {
			category: TrackingCategories.ACCOUNT_PAGE,
			action: TrackingActions.CONTENT_SWITCHER_SWITCHED,
			label: `${container}_${to}`,
			property: `from_${container}_${from}`,
		};

		this.snowPlow(trackingParams);
	}

	public trackOpenRecommendations(label: string): void {
		const trackingParams: ITrackingObject = {
			category: TrackingCategories.ACCOUNT_PAGE,
			action: TrackingActions.CONTENT_SWITCHER_SWITCHED,
			label,
		};

		this.snowPlow(trackingParams);
	}

	public trackSectionSwitch(from: PageSectionType, to: string): void {
		const trackingParams: ITrackingObject = {
			category: TrackingCategories.ACCOUNT_PAGE,
			action: TrackingActions.SECTION_SWITCH,
			label: to,
			property: `from_${from}`,
		};

		this.snowPlow(trackingParams);
	}

	private snowPlow(trackingParams: ITrackingObject): void {
		if (typeof window.snowplow === 'undefined') {
			return;
		}

		window.snowplow('trackStructEvent', trackingParams);
	}
}
